module.exports = __webpack_public_path__ + "Uplayplus_LP_carousel_PoPFS_tablet.png";